(function employeeFileSearchDirectiveDefinition() {

    'use strict';

    // esta directiva va a usar el mismo modulo de EmployeeFile,
    // por eso el component.json tiene como dependencia a la componente padre.
    angular.module('EmployeeFile')
        .directive('employeeFileSearch', ['config',
            function employeeFileSearchDirective(config) {

                return {
                    restrict: 'E',
                    templateUrl: config.resourceUrl('/directives/employee-file-search/employee-file-search.html'),
                    scope: {
                        selectedEmployeeFile: '=ngModel',
                        ngBlur: '&',
                        headers: '=',
                        name: '@',
                        numberplaceholder: '@',
                        descriptionplaceholder: '@',
                        allowEdit: '=',
                        employeeFileNumber: '=',
                        multipleSelection: '=',
                        unitOrgId: '='
                    },
                    controller: [
                        '$scope', '$element', '$attrs', '$uibModal', 'config', 'documentContainerService', 'containerTypeService', 'errorsExtend', 'storageService', '$filter', 'adminContainerTypeService', 'authExtend',
                        function collapsableMenuController($scope, $element, $attrs, $modal, config, documentContainerService, containerTypeService, errors, storageService, $filter, adminContainerTypeService, authExtend) {

                            $scope.find = storageService.getEmployeeFilesFilter();
                            $scope.loadContainerType = function () {
                                $scope.containerDetail = $scope.containerDetail || 'simple';
                                $scope.filter = ['_nroleg', '_nom', '_ape', '_cuil', '_userId'];
                                $scope.systemNames = {};

                                var rootOu = authExtend.getOrganizationRoot();

                                adminContainerTypeService.getMetadataMappings(rootOu).then(function (result) {
                                    var customContainerType = undefined;

                                    for (var i = 0; i < result.length; i++) {
                                        if (result[i].sourceMetadataMapping.length > 0 && result[i].targetMetadataMapping.length > 0) {
                                            customContainerType = result[i];
                                        }
                                    }

                                    if (customContainerType) {
                                        $scope.loadMetadata(customContainerType, true);
                                    } else {
                                        containerTypeService.getBySystemName("_leg").then(function (result) {
                                            $scope.loadMetadata(result);
                                        }, function (error) {
                                         });
                                    }
                                });

                            };

                            $scope.loadMetadata = function (containerType, isCustomContainerType) {
                                if (isCustomContainerType) {
                                    containerType.targetMetadataMapping.forEach(function (item, index) {
                                        if ($scope.filter.indexOf(item.metadataSystemName) >= 0) {
                                            $scope.systemNames[item.metadataSystemName] = {
                                                sn: containerType.sourceMetadataMapping[index].metadataSystemName,
                                                label: containerType.sourceMetadataMapping[index].metadataLabel,
                                                visible: containerType.sourceMetadataMapping[index].isResultCriteria
                                            };
                                        }
                                    });
                                } else {
                                    containerType.metadata.forEach(function (metadata) {
                                        if ($scope.filter.indexOf(metadata.metadataSystemName) >= 0) {
                                            $scope.systemNames[metadata.metadataSystemName] = {
                                                sn: metadata.metadataSystemName,
                                                label: metadata.metadataLabel,
                                                visible: metadata.isResultCriteria
                                            };
                                        }
                                    });
                                }

                                if ($scope.find.employeeFileTypes.length > 0) {
                                    return;
                                }

                                var type = {
                                    SystemName: containerType.systemName,
                                    employeeFileTypeName: containerType.name,
                                    employeeFileTypeId: containerType.id,
                                    metadatas: []
                                };

                                containerType.metadata.forEach(function (metadata) {
                                    var addMetadata = $scope.filter.some(function (sn) {
                                        return $scope.systemNames[sn].sn === metadata.metadataSystemName;
                                    });

                                    if (addMetadata && metadata.isSearchCriteria) {
                                        type.metadatas.push({
                                            idObject: type.employeeFileTypeId + '' + metadata.metadataId,
                                            metadataId: metadata.metadataId,
                                            metadataValueFrom: undefined,
                                            metadataValueTo: undefined,
                                            metadataSearchTypeFrom: undefined, // cada control pisa el valor
                                            metadataSearchTypeTo: undefined, // cada control pisa el valor
                                            metadataType: metadata.metadataType,
                                            metadataSystemName: metadata.metadataSystemName,
                                            metadataLabel: metadata.metadataLabel,
                                            metadataOptions: metadata.optionValues
                                        });
                                    }
                                });

                                $scope.find.employeeFileTypes.push(type);
                            };

                            $scope.search = function () {
                                if (!$scope.employeeFileNumber) {
                                    return $scope.openModal();
                                } else {
                                    return $scope.selectEmployeeFile();
                                }
                            };

                            $scope.openModal = function () {
                                $scope.employeeFileDescription = '';
                                $scope.employeeFileNumber = '';
                                
                                var modalInstance = $modal.open({
                                    templateUrl: config.resourceUrl('/directives/employee-file-search/employee-file-search-modal.html'),
                                    controller: 'EmployeeFileSearchModalController',
                                    size: 'lg',
                                    resolve: {
                                        unitOrgId: function () {
                                            return $scope.unitOrgId;
                                        },
                                        multipleSelection: function () {
                                            return $scope.multipleSelection;
                                        }
                                    }
                                });

                                return modalInstance.result.then(function (result) {
                                    if (result) {
                                        if ($scope.multipleSelection) {
                                            angular.forEach(result.items, function (item) {
                                                $scope.addEmployeeFile(item);
                                            });
                                            $scope.headers = result.headers;
                                        } else {
                                            $scope.employeeFileNumber = result.metadata[0];
                                            $scope.selectSingleEmployeeFile(result);
                                        }
                                    }
                                });
                            };

                            $scope.selectEmployeeFile = function () {
                                storageService.setEmployeeFilesFilter($scope.find);

                                var filters = {
                                    Complete: true,
                                    ContainerTypes: [],
                                    OrganizationUnitIds: $scope.unitOrgId ? [$scope.unitOrgId] : undefined
                                };

                                $scope.find.employeeFileTypes[0].Page = 1,
                                    $scope.find.employeeFileTypes[0].DocumentTypeId = $scope.find.employeeFileTypes[0].employeeFileTypeId;
                                $scope.find.employeeFileTypes[0].metadatas.forEach(function (meta) {
                                    if (meta.metadataSystemName == $scope.systemNames._nroleg.sn) {
                                        meta.metadataValueFrom = $scope.employeeFileNumber;
                                    }
                                });

                                filters.ContainerTypes.push($scope.find.employeeFileTypes[0]);
                                filters.ContainerTypes[0].OrganizationUnitIds = $scope.unitOrgId ? [$scope.unitOrgId] : undefined;

                                return documentContainerService.advancedGet(filters).then(function (result) {
                                    if (result.values && result.values.length > 0) {
                                        if ($scope.multipleSelection == true) {
                                            $scope.headers = [];
                                            var item = {
                                                id: result.values[0].id,
                                                organizationalUnitName: result.values[0].organizationalUnitName,
                                                organizationalUnitId: result.values[0].organizationalUnitId,
                                                metadata: []
                                            };

                                            for (var i = 0; i < $scope.filter.length; i++) {
                                                var idx = result.headers.indexOf($scope.systemNames[$scope.filter[i]].label);

                                                if (idx >= 0) {
                                                    $scope.headers.push(result.headers[idx]);
                                                    item.metadata.push(result.values[0].metadata[idx]);
                                                }
                                            }

                                            $scope.addEmployeeFile(item);
                                        } else {
                                            $scope.selectSingleEmployeeFile(result.values[0]);
                                        }
                                    } else {
                                        $scope.openModal();
                                    }

                                }, function (result) {
                                    $scope.openModal();
                                });
                            };

                            $scope.selectSingleEmployeeFile = function (item) {
                                return documentContainerService.getById(item.id).then(function (result) {
                                    $scope.selectedEmployeeFile = result;

                                    result.metadatas.forEach(function (meta) {
                                        if (meta.metadataSystemName == $scope.systemNames._userId.sn) {
                                            $scope.selectedEmployeeFile.userId = meta.metadataValue;
                                        }
                                        if (meta.metadataSystemName == $scope.systemNames._ape.sn) {
                                            $scope.selectedEmployeeFile.Description = meta.metadataValue;
                                        }

                                        if (meta.metadataSystemName == $scope.systemNames._nom.sn) {
                                            $scope.selectedEmployeeFile.Description = $scope.selectedEmployeeFile.Description + " " + meta.metadataValue;
                                        }
                                    });
                                }, function (error) {
                                    errors.showError(error);
                                });
                            };

                            $scope.addEmployeeFile = function (item) {
                                $scope.employeeFileNumber = '';

                                if (!Array.isArray($scope.selectedEmployeeFile)) {
                                    $scope.selectedEmployeeFile = [];
                                }

                                var exists = $filter('filter')($scope.selectedEmployeeFile, { id: item.id }, true);

                                if (exists.length === 0) {
                                    $scope.selectedEmployeeFile.unshift(item);
                                }
                            };

                            $scope.loadContainerType();
                        }]
                };
            }]);
})();